import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { FormButtonComponent } from 'Shared/app/components/wfs-form-button/form-button.component';
import { ConfirmModalData } from '../new-confirm-modal/new-confirm-modal.component';

@Component({
  selector: 'wfs-confirm-modal',
  templateUrl: './confirm-modal.component.html',
  styleUrls: ['./confirm-modal.component.scss'],
  imports: [FormButtonComponent, MatDialogModule]
})
export class ConfirmModalComponent {
  readonly data = inject<ConfirmModalData>(MAT_DIALOG_DATA);
  readonly #dialogRef = inject(MatDialogRef);

  triggerEvent(value: boolean): void {
    this.#dialogRef.close(value);
  }
}
